import DateUtils from "../../../utils/DateUtils";

export default function DisplayDayIso(props) {
  const { date } = props;

  return DateUtils.localDateToTimelessIsoString(new Date(date));
}
